export default __webpack_public_path__ + "static/media/bracket_omegaveer_3x_tbs_ketel_isolatie_1.4505b35c.png";